import { Outlet } from 'react-router-dom';
import MainHeader from './header';


const MenuLayout = () => {
  // const color1 = "#c2ded3";
  // const color2 = "#b9d9e6";
  const color1 = "#C2DED2";
  const color2 = "#B9D9E4";
  return (
    <div 
      style={{
        background: `linear-gradient(90deg, ${color1}, ${color2})`, 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent:'flex-start', 
        width: '100%', 
        height: '100%', 
        overflow: 'hidden' 
        }}
    >
      <MainHeader></MainHeader>
      <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
        <Outlet />
      </div>
    </div>
  );
};

// const MenuLayout = () => {
//   const color1 = "#c2ded3";
//   const color2 = "#b9d9e6";
//   return (
//     <div style={{display: 'flex', flexDirection: 'column', justifyContent:'flex-start', width: '100%', height: '100%', overflow: 'hidden' }}>
//           <div style={{width: '100%', height: '15%'}}>
//             <MainHeader/>
//           </div>
//           <div style={{ background: `linear-gradient(90deg, ${color1}, ${color2})`, width: '100%', height: '85%', overflow: 'auto' }}>
//             <Outlet />
//           </div>
//     </div>
//   );
// };

export default MenuLayout;
